import { lazy } from '@/service/lazy'
import home from './home'
import dashboard from './dashboard'
import pedido from './pedido'
// import regrastabelas from './regrastabelas'
import comissao from './comissao'
import hiscon from './hiscon'
import extrato from './extrato'
import pacotesfornecedor from './pacotesfornecedor'
import pacotesunidade from './pacotesunidade'
import empresa from './empresa'
import unidade from './unidade'
import usuario from './usuario'
// import contrato from './contrato'
import roteiro from './roteiro'
import link from './link'
import comunicado from './comunicado'
import perfil from './perfil'
import listagem from './listagem'
import limiteusuarios from './limiteusuarios'
import regras from './regras'
import novoscadastros from './novoscadastros'
import limitecadastrosdiarios from './limitecadastrosdiarios'
import gerenciarleads from './gerenciarleads'
import usuariosativos from './usuariosativos'
import vendedor from './vendedor'
import comissaovendedores from './comissao-vendedores'
import usuariosativosvendedor from './usuariosativosvendedor'
import semacoes from './semacoes'
import planosassinaturas from './planosassinaturas'
import assinatura from './assinatura'
import repassecomissao from './repassecomissao'
import statusassinatura from './statusassinatura'
import promotora from './promotora'
import listagemInss from './listagemInss'
import listagemSiape from './listagemSiape'
import consultasparceiro from './consultasparceiro'
import regrasbancos from './regrasbancos'
import instituicoes from './instituicoes'
import financeiro from './financeiro'

export default [{
  name: 'Default',
  path: '/',
  redirect: 'dashboard',
  meta: { requireAuth: true },
  component: lazy('app/default/index'),
  children: [
    ...home,
    ...dashboard,
    ...pedido,
    // ...regrastabelas,
    ...comissao,
    ...hiscon,
    ...extrato,
    ...pacotesfornecedor,
    ...pacotesunidade,
    ...unidade,
    ...limiteusuarios,
    ...empresa,
    ...usuario,
    // ...contrato,
    ...roteiro,
    ...link,
    ...comunicado,
    ...perfil,
    ...listagem,
    ...regras,
    ...novoscadastros,
    ...limitecadastrosdiarios,
    ...gerenciarleads,
    ...usuariosativos,
    ...vendedor,
    ...comissaovendedores,
    ...usuariosativosvendedor,
    ...semacoes,
    ...planosassinaturas,
    ...assinatura,
    ...repassecomissao,
    ...statusassinatura,
    ...promotora,
    ...listagemInss,
    ...listagemSiape,
    ...consultasparceiro,
    ...regrasbancos,
    ...instituicoes,
    ...financeiro
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/index.js